var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2885_6076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3541 1.2463C26.2521 -0.588974 22.8279 0.0358042 15.8221 0.426289C12.0043 0.660579 6.76965 0.816769 0.4723 0.660576C0.432941 0.660576 0.31487 0.660574 0.236153 0.738671C0.157436 0.816768 0.118076 0.894865 0.118076 0.933913C0.118076 27.7992 0.0393584 39.7481 0 40.6852C0 40.6852 0 40.8024 0 40.8805C0 40.9586 0.629736 42.7157 2.87317 43.4967C3.34547 43.6529 4.13264 43.692 5.62825 43.8091C7.12387 43.8872 7.83232 43.8091 8.54078 43.5748C9.28858 43.3405 9.64282 43.2234 9.83961 42.8719C10.0758 42.4814 9.95768 42.13 9.68217 39.709C9.52473 38.7328 9.40666 37.6004 9.20987 36.1947C9.05244 34.086 8.895 32.446 8.73757 31.3526C8.73757 31.3526 8.65886 30.6888 8.85565 25.4954C8.85565 25.4173 8.85564 25.2611 8.97372 25.1439C9.09179 25.0268 9.20988 24.9877 9.24923 24.9877C10.2332 24.9097 11.3746 24.8706 12.634 24.9877C12.634 24.9877 16.0582 25.0658 18.5772 26.1983C18.6952 26.2373 18.892 26.3544 19.0101 26.5497C19.2069 26.823 19.2069 27.1745 19.2069 27.3697C19.2856 29.6345 19.325 31.4698 19.325 32.7584C19.325 37.6394 19.0101 41.9738 18.774 45.6834C18.6559 47.3234 18.6165 47.5577 18.5772 48.4949C18.4197 51.775 18.5378 54.4693 18.6165 56.2265C18.6165 56.4608 18.6559 56.8122 18.8133 57.2027C18.8527 57.3198 19.0495 57.8275 19.4824 58.3351C19.6005 58.4522 20.2302 59.1942 21.3323 59.5456C21.5291 59.6237 21.6471 59.6237 23.0247 59.7799C24.7171 59.9751 25.15 59.9751 25.4255 59.9751C26.8818 60.0532 27.2754 59.9361 27.6296 59.7799C27.8658 59.6628 28.2987 59.4675 28.6136 59.077C29.0465 58.4523 28.9678 57.6713 28.8891 57.2418C28.5742 55.1722 28.2987 53.1026 27.9445 51.0331C27.8264 50.3302 27.8264 50.0568 27.6296 47.9873C27.6296 47.9873 26.8031 38.3814 27.787 24.2849C27.787 24.1287 27.8264 23.6991 28.1019 23.3477C28.4561 22.8791 28.9284 22.7229 29.0465 22.6839C29.9911 22.5277 31.408 22.3715 33.1398 22.4887C35.2651 22.6448 37.115 22.762 38.5713 24.0506C39.9488 25.2611 40.3424 26.823 40.6179 28.0335C40.8934 29.1269 41.5231 31.7431 40.1062 34.3984C39.7126 35.1403 38.6893 37.1318 36.682 37.7566C35.3045 38.1861 33.2972 37.9909 32.9824 37.9518C32.0378 37.8737 31.2899 37.6785 30.3847 38.069C30.1092 38.1861 29.5188 38.4595 29.0859 39.0842C28.4955 40.0604 28.8104 41.1538 28.9678 41.6224C29.4795 43.2234 30.8176 44.0434 31.0144 44.1605C31.8803 44.6682 33.1004 44.9805 36.3672 44.2777C39.752 43.5357 41.5231 43.1843 43.6091 41.7395C47.9386 38.7718 49.198 34.2422 49.4735 33.1489C49.8278 31.7041 50.8511 27.4478 48.4896 23.4258C46.4429 19.9505 43.0188 18.6619 40.9328 17.8809C37.7841 16.7095 35.2258 16.7485 31.0932 16.8266C26.5276 16.9047 22.2375 17.7638 21.1355 18.1152C21.0174 18.1543 20.3877 18.3495 19.5218 18.5057C18.774 18.6619 18.1836 18.6619 17.9474 18.7009C17.9474 18.7009 12.2405 19.0524 9.28858 18.7009C9.24922 18.7009 9.17051 18.701 9.09179 18.6229C9.01307 18.5838 8.97372 18.5057 8.97372 18.4667C8.97372 14.718 8.97372 10.9303 8.97372 7.18166C9.52474 7.29881 10.3119 7.41595 11.2565 7.57215C12.3192 7.72834 15.153 8.11882 19.6792 8.15787C22.6311 8.19692 24.0874 8.19692 24.7958 7.76739C27.0392 6.36165 28.4168 3.00348 27.3541 1.2463Z",
    fill: "#F7941D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2885_6076",
    x: -4,
    y: -4,
    width: 58,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.579167 0 0 0 0 0.316151 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2885_6076"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.958333 0 0 0 0 0.899218 0 0 0 0 0.82816 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2885_6076",
    result: "effect2_innerShadow_2885_6076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.014e0b2f735cbc59a4e517659db3c06e.svg";
export { ForwardRef as ReactComponent };